module.exports = __webpack_public_path__ + "img/logo-fifalotto-white5-slotpg.665a750e.png";